import { TIPOS_SERVICIOS_PRODUCTO, PRODUCTOS_BUSQUEDA } from '@/resources/constants';
var ProductsMixin = {
  methods: {
    esAExito(tipo) {
      return (tipo.localeCompare(TIPOS_SERVICIOS_PRODUCTO.A_EXITO) == 0);
    },
    esPrepago(tipo) {
      return (tipo.localeCompare(TIPOS_SERVICIOS_PRODUCTO.PREPAGO) == 0);
    },
    esConsumo(tipo) {
      return (tipo.localeCompare(TIPOS_SERVICIOS_PRODUCTO.CONSUMO) == 0);
    },
    textoComboTipoProducto(valorLiteral, plataformaLiteral) {
      var str = valorLiteral + " (" + plataformaLiteral + ")";
      return str;
    },
    servicioConsumo() {
      return TIPOS_SERVICIOS_PRODUCTO.CONSUMO;
    },
    arrayProductosBusqueda() {
      return [].concat.apply([], Object.entries(PRODUCTOS_BUSQUEDA))
    }
  }
};
export default ProductsMixin;